import { Suspense } from 'react';

import { cn } from '~/shared/lib/cn';

import { Skeleton } from '../skeleton';
import { Toaster } from '../toaster';

type Properties = React.HTMLAttributes<HTMLDivElement> & {
  topBar?: React.ReactNode;
  sideBar?: React.ReactNode;
};

export function PageLayout({
  topBar = null,
  sideBar = null,
  className,
  children,
  ...properties
}: Properties) {
  return (
    <div
      className={cn(
        'container flex min-h-screen min-w-[22rem] max-w-[79rem] flex-col divide-y divide-muted px-4 *:py-4',
        className,
      )}
      {...properties}
    >
      {topBar}
      <div className="flex gap-4">
        {sideBar}
        <main className="w-full">
          <Suspense fallback={<Skeleton type="page" />}>{children}</Suspense>
        </main>
      </div>
      <Toaster position="top-center" richColors />
    </div>
  );
}
